import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import ToolBlock from "../../components/AdministrativeProcedures/commonComponents/ToolBlock/ToolBlock";
import ModalWindow from "../../components/AdministrativeProcedures/commonComponents/ModalWindow/ModalWindow";
import SearchBlockRHF from "./../../components/GeneralComponents/searchBlockRHF/SearchBlockRHF";
import TableComponent from "../../components/GeneralComponents/SearchTable/tableComponent";

import { getDataRegInfChangeBoatCardsBySearchParams } from "../../redux/RegistrationInformationChangesReducer/actionRegInfChanges";
import { getDataTechExamBoatCardsBySearchParams } from "../../redux/TechnicalExaminationReducer/actionsTechnicalExamination";
import { getDataBoatCardsDuplShipsTicketsBySearchParams } from "../../redux/DuplicateShipsTicketReducer/actionsDuplicateShipsTicket";

import { options } from "./../../components/GeneralComponents/searchBlockRHF/optionsSearchBlockRHF";

import {
  COLUMNS_FORM_SEARCH_BOAT_CARDS,
  COLUMNS_FORM_SEARCH_BOAT_CARDS_DUPLICATES,
} from "../../components/GeneralComponents/SearchTable/TablesColumns";

import styles from "./FormSearchBoatCard.module.css";
import ResultModalWindow from "../../components/AdministrativeProcedures/commonComponents/ResultModalWindow/ResultModalWindow";

function FormSearchBoatCard() {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { additionalAccess } = location.state || {};

  const [showResultModal, setShowResultModal] = useState(false);
  const [registrationResult, setRegistrationResult] = useState("");
  const [appId, setAppId] = useState(null);
  const [errorText, setErrorText] = useState("");
  const [headerText, setHeaderText] = useState("");
  const [show, setShow] = useState(false);
  const [dataForTable, setDataForTable] = useState({});
  const [locationInfo, setLocationInfo] = useState("");
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [selectedPage, setSelectedPage] = useState(0);
  const [searchParams, setSearchParams] = useState(
    window.location.pathname === "/dupshipsticket/searchboatcard"
      ? {
          ownerSurname: "",
          ownerName: "",
          ownerMidname: "",
          regNum: "",
          boatVin: "",
          engvin: "",
        }
      : {
          ownerSurname: "",
          ownerName: "",
          ownerMidname: "",
          regNum: "",
          leName: "",
          leUnp: "",
          boatVin: "",
          engvin: "",
        },
  );

  const dataBoatCardsRegInfChange = useSelector((state) => {
    const { registrationInformationChangesReducer } = state;
    return registrationInformationChangesReducer.dataBoatCards;
  });
  const dataBoatCardsTechExam = useSelector((state) => {
    const { TechnicalExaminationReducer } = state;
    return TechnicalExaminationReducer.dataBoatCards;
  });
  const duplicateShipsTicketReducer = useSelector((state) => {
    const { DuplicateShipsTicketReducer } = state;
    return DuplicateShipsTicketReducer.dataBoatCards;
  });

  const handleChange = (e) => {
    if (e.target) {
      setSearchParams({
        ...searchParams,
        [e.target.dataset.id]: e.target.value,
      });
    } else {
      setSearchParams({ ...searchParams, [e.key]: e.value });
    }
  };

  const handleSearch = () => {
    switch (locationInfo) {
      case "techexamination":
        dispatch(getDataTechExamBoatCardsBySearchParams(searchParams, 0));
        break;
      case "dupshipsticket":
        dispatch(
          getDataBoatCardsDuplShipsTicketsBySearchParams(searchParams, 0),
        );
        break;
      case "reginformationchanges":
        dispatch(getDataRegInfChangeBoatCardsBySearchParams(searchParams, 0));
        break;
    }
    setSelectedPage(0);
    setSelectedRowData(null);
  };

  const handleClear = () => {
    setSelectedPage(0);
    setSelectedRowData(null);
    setSearchParams(
      structuredClone(
        locationInfo === "dupshipsticket"
          ? {
              ownerSurname: "",
              ownerName: "",
              ownerMidname: "",
              regNum: "",
              boatVin: "",
              engvin: "",
            }
          : {
              ownerSurname: "",
              ownerName: "",
              ownerMidname: "",
              regNum: "",
              leName: "",
              leUnp: "",
              boatVin: "",
              engvin: "",
            },
      ),
    );

    switch (true) {
      case locationInfo === "techexamination":
        dispatch(
          getDataTechExamBoatCardsBySearchParams(
            {
              ownerSurname: "",
              ownerName: "",
              ownerMidname: "",
              regNum: "",
              leName: "",
              leUnp: "",
              boatVin: "",
              engvin: "",
            },
            0,
          ),
        );
        break;
      case locationInfo === "dupshipsticket":
        dispatch(
          getDataBoatCardsDuplShipsTicketsBySearchParams(
            {
              ownerSurname: "",
              ownerName: "",
              ownerMidname: "",
              regNum: "",
              boatVin: "",
              engvin: "",
            },
            0,
          ),
        );
        break;
      default:
        dispatch(
          getDataRegInfChangeBoatCardsBySearchParams(
            {
              ownerSurname: "",
              ownerName: "",
              ownerMidname: "",
              regNum: "",
              leName: "",
              leUnp: "",
              boatVin: "",
              engvin: "",
            },
            0,
          ),
        );
        break;
    }
  };

  const handleRowSelect = (rowData) => {
    setSelectedRowData(rowData);
  };

  const fetchPageData = (pageIndex) => {
    setSelectedPage(pageIndex);
  };

  const handleHistoricalCardNotion = () => {
    setHeaderText("Исторические данные");
    setErrorText(
      "Для работы с историческими данными перейдите в раздел Маломерные суда и отредактируйте необходимую РК маломерного судна, заполнив все обязательные поля",
    );
    setShowResultModal(true);
  };

  useEffect(() => {
    switch (true) {
      case window.location.pathname === "/techexamination/searchboatcard":
        setLocationInfo("techexamination");
        break;
      case window.location.pathname === "/dupshipsticket/searchboatcard":
        setLocationInfo("dupshipsticket");
        break;
      case window.location.pathname === "/reginformationchanges/searchboatcard":
        setLocationInfo("reginformationchanges");
        break;
    }
  }, []);

  useEffect(() => {
    switch (locationInfo) {
      case "techexamination":
        dispatch(getDataTechExamBoatCardsBySearchParams(searchParams, 0));
        break;
      case "dupshipsticket":
        dispatch(
          getDataBoatCardsDuplShipsTicketsBySearchParams(searchParams, 0),
        );
        break;
      case "reginformationchanges":
        dispatch(getDataRegInfChangeBoatCardsBySearchParams(searchParams, 0));
        break;
    }
  }, [locationInfo]);

  useEffect(() => {
    switch (locationInfo) {
      case "techexamination":
        setDataForTable(dataBoatCardsTechExam);
        break;
      case "dupshipsticket":
        setDataForTable(duplicateShipsTicketReducer);
        break;
      case "reginformationchanges":
        setDataForTable(dataBoatCardsRegInfChange);
        break;
    }
  }, [
    dataBoatCardsTechExam,
    duplicateShipsTicketReducer,
    dataBoatCardsRegInfChange,
  ]);

  useMemo(() => {
    setSelectedRowData(null);
    switch (locationInfo) {
      case "techexamination":
        dispatch(
          getDataTechExamBoatCardsBySearchParams(searchParams, selectedPage),
        );
        break;
      case "dupshipsticket":
        dispatch(
          getDataBoatCardsDuplShipsTicketsBySearchParams(
            searchParams,
            selectedPage,
          ),
        );
        break;
      case "reginformationchanges":
        dispatch(
          getDataRegInfChangeBoatCardsBySearchParams(
            searchParams,
            selectedPage,
          ),
        );
        break;
    }
  }, [selectedPage]);

  useEffect(() => {
    fetchPageData(0);
  }, []);

  return (
    <div className={styles["content-container"]}>
      <p className={styles["back-block"]} onClick={() => navigate(-1)}>
        <span className={styles["back-icon"]}></span>
        <p className={styles["back-text"]}>{"Вернуться к заявлениям"}</p>
      </p>
      <SearchBlockRHF
        options={
          locationInfo === "dupshipsticket"
            ? options.inputsFormSearchBoatCardDupshipsticket
            : options.inputsFormSearchBoatCardTechAndInfoChange
        }
        handleChange={handleChange}
        handleSearch={handleSearch}
        handleClear={handleClear}
        searchParams={searchParams}
        externalStyles={styles}
      />
      <ToolBlock
        id={selectedRowData?.id}
        data={
          locationInfo === "techexamination"
            ? dataBoatCardsTechExam
            : dataBoatCardsRegInfChange
        }
        personType={
          locationInfo === "techexamination" && selectedRowData?.ownerType
        }
        setShow={setShow}
        addBtnDisIn={!Boolean(selectedRowData?.id)}
        selectedRowData={selectedRowData}
        additionalAccess={additionalAccess}
        handleData={handleHistoricalCardNotion}
      />
      <TableComponent
        fetchData={fetchPageData}
        onRowSelect={handleRowSelect}
        columns={
          locationInfo === "dupshipsticket"
            ? COLUMNS_FORM_SEARCH_BOAT_CARDS_DUPLICATES
            : COLUMNS_FORM_SEARCH_BOAT_CARDS
        }
        data={dataForTable.content || []}
        totalPages={dataForTable.totalPages || 0}
        totalElements={dataForTable.totalElements || 0}
        selectedPage={selectedPage}
      />
      {show && (
        <ModalWindow
          show={show}
          setShow={setShow}
          idBoadCard={selectedRowData?.id}
        />
      )}
      {showResultModal && (
        <ResultModalWindow
          appId={appId}
          show={showResultModal}
          setShow={setShowResultModal}
          result={registrationResult}
          errorText={errorText}
          headerTextExternal={headerText}
        />
      )}
    </div>
  );
}

export default FormSearchBoatCard;
